module.exports = __webpack_public_path__ + "static/assets/9218bcead8c823078f24d088bae4dc6c.png";